import { validateEmail, validateAddress } from '../Shared/validations.js';
import { copyFor } from '../../copy/copy';

const validatePrefix = (values, isMultiRep) => {
    if (!values) return;
    if (values.prefix == null || values.prefix === '') {
        return {
            prefix: isMultiRep
                ? copyFor('validationErrors', 'invalid', 'email')
                : copyFor('validationErrors', 'prefix', 'email')
        };
    }
    return {};
};

const validateTopic = values => {
    if (!values) return;
    if (values.topic == null || values.topic === '') {
        return { topic: copyFor('validationErrors', 'subject', 'email') };
    }
    return {};
};

const validateStreet = values => {
    if (!values) return;
    const addressValidated = validateAddress({ address: values.address });
    if (addressValidated.address) {
        return { address: addressValidated.address };
    }
    return {};
};

const validateCity = values => {
    if (!values) return;
    if (values.homeCity == null || values.homeCity === '') {
        return { homeCity: copyFor('validationErrors', 'city') };
    }
    return {};
};

const validateCounty = values => {
    if (!values) return;
    if (values.county == null || values.county === '') {
        return { county: copyFor('validationErrors', 'county') };
    }
    return {};
};

const validatePostalCode = values => {
    if (!values) return;
    if (values.postalCode == null || values.postalCode === '') {
        return { postalCode: copyFor('validationErrors', 'postalCode') };
    }
    return {};
};

const validatePhone = values => {
    if (!values) return;
    if (values.phone == null || values.phone === '') {
        return { phone: copyFor('validationErrors', 'phone') };
    }
    return {};
};

const validateFullName = values => {
    if (!values) return;
    if (values.fullName == null || values.fullName === '') {
        return { fullName: copyFor('validationErrors', 'fullName') };
    }
    const split = values.fullName.split(' ');
    if (split.length > 1 && split[0] !== '' && split[1] !== '') return {};

    return { fullName: copyFor('validationErrors', 'fullName') };
};

const validateMessage = values => {
    if (!values || values.message === 'RecordVideoActionPlaceholder') return;
    if (values.message === null || values.message === '') {
        return { message: copyFor('validationErrors', 'message') };
    }
    else if (values.message && values.message.length < 65) return { message: copyFor('validationErrors', 'shortMessage') };
    return {};
};

const validateSubject = values => {
    if (!values) return;
    if (values.subject === null || values.subject === '') {
        return { subject: copyFor('validationErrors', 'subject', 'email') };
    }
    return {};
};

const validate = values => {
    const errors = {
        ...validatePrefix(values),
        ...validateFullName(values),
        ...validateEmail(values),
        ...validateMessage(values)
    };

    return errors;
};

export const validateStep1 = values => {
    let errors = {
        ...validateMessage(values)
    };

    if (values) {
        if (Object.keys(values).includes('topic')) {
            errors = {
                ...errors,
                ...validateTopic(values)
            };
        }

        if (Object.keys(values).includes('subject')) {
            errors = {
                ...errors,
                ...validateSubject(values)
            };
        }
    }
    return errors;
};

export const validateStep2 = (values, props) => {
    let errors = {
        ...validateFullName(values),
        ...validateEmail(values),
        ...validateAddress(values),
        ...validateStreet(values),
        ...validateCity(values),
        ...validateCounty(values),
        ...validatePostalCode(values)
    };

    if (props && props.isRecordVideoAction){
        errors = {
            ...errors,
            ...validateTopic(values, true)
        };
    }

    if (values) {
        if (Object.keys(values).includes('prefix')) {
            errors = {
                ...errors,
                ...validatePrefix(values, true)
            };
        }
        if (Object.keys(values).includes('phone')) {
            errors = {
                ...errors,
                ...validatePhone(values)
            };
        }
    }
    return errors;
};

export default validate;
